document.addEventListener('DOMContentLoaded', function() {
  const paragraphs = document.querySelectorAll('#product-description p');
  // Add the "Read More" toggle functionality
  document.querySelector('.readmore').addEventListener('click', function(event) {
    event.preventDefault();
    const description = document.querySelector('#product-description');
    if (description.classList.contains('expanded')) {
      description.classList.remove('expanded');
      this.textContent = 'Read More...';
    } else {
      description.classList.add('expanded');
      this.textContent = 'Read Less...';
    }
  });
});

document.querySelectorAll('#product-description p').forEach(function(oneP, index, allP) {
  if (allP[index + 1] && allP[index + 1].querySelector('script')) {
    oneP.style.marginBottom = '0px';
  }
});

// Replace all non-breaking spaces in a specific element
document.querySelectorAll('.product-description-container *').forEach(el => {
  if (el.childNodes) {
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.nodeValue = node.nodeValue.replace(/\u00A0/g, ''); // Replace with a regular space
      }
    });
  }
});

// Custom code for hsa/fsa badge under quantity
document.addEventListener("DOMContentLoaded", function () {
  // Find the div with class containing product-block--@app
  const appBlock = document.querySelector(".product-app");
  const rcWrapper = document.querySelector(".options-selection__select-wrapper");
  const qtyWrapper = document.querySelector(".product-form__action-wrapper");

  if ((appBlock && rcWrapper) || (appBlock && qtyWrapper)) {
    // Remove and append
      
      if (rcWrapper) {
          appBlock.remove();
          // insert before options-selection__select-wrapper
          rcWrapper.insertAdjacentElement("beforebegin", appBlock);

      } else if (qtyWrapper) {
          appBlock.remove();
          // insert before product-form__action-wrapper
          qtyWrapper.insertAdjacentElement("beforebegin", appBlock);
      }
  }
});